// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutCompany_wrapper__100AM"};